import { NgxsModule } from '@ngxs/store';
import { CollectionsState } from './collections/collections.state';
import { HomeState } from './home/home.state';
import { UserListState } from './user-list/user-list.state';
import { CareerPlansState } from './career-plans/career-plans.state';
import { ChallengesState } from '../challenges/state/challenges.state';
import { UserConfigState } from './user-config/user-config.state';
import { HoldsState } from './user/holds/holds.state';
import { SearchesState } from './user/searches/searches.state';
import { CheckoutsState } from './user/checkouts/checkouts.state';
import { AccessibilityState } from '../_core/accessibility/state/accessibility.state';
import { FooterState } from './footer/footer.state';
import { FavoritesState } from './user/favorites/favorites.state';
import { ErrorDialogState } from '../_core/state/dialogs/error/error.state';
import { HelpButtonState } from '../_core/state/dialogs/help-button/help-button.state';
import { GamificationState } from '../gamification/state/gamification.state';
import { EditingState } from '../_core/state/dialogs/editing/editing.state';
import { CitationState } from '../_core/state/dialogs/citation/citation.state';
import { ReportDialogState } from '../_core/state/dialogs/report/report.state';
import { LoginState } from '../login/state/login.state';
import { ToastState } from '../_core/state/toasts/toast.state';
import { ExternalVideoState } from '../_core/state/dialogs/external-video/external-video.state';
import { RatingState } from '../_core/state/dialogs/rating/rating.state';
import { InfoState } from '../_core/state/dialogs/info/info.state';
import { BookclubLinksState } from '../_core/state/dialogs/bookclub-links/bookclub-links.state';
import { AmautasSubscriptionDialogState } from '../_core/state/dialogs/amautas-subscription/amautas-subscription.state';
import { HistoryState } from './user/history/history.state';
import { CookiesState } from '../_core/state/dialogs/cookies/cookies.state';
import { FiltersState } from '../filters/state/filters.state';
import { FacetsState } from './facets/facets.state';
import { ActiveRecordsState } from './active-records/active-records.state';
import { ConfirmationDialogState } from '../_core/state/dialogs/confirmation-dialog/confirmation-dialog.state';

export const stateInitializationModule = NgxsModule.forRoot([
  CollectionsState,
  HomeState,
  UserListState,
  CareerPlansState,
  ChallengesState,
  UserConfigState,
  HoldsState,
  SearchesState,
  CheckoutsState,
  AccessibilityState,
  FooterState,
  FavoritesState,
  EditingState,
  HelpButtonState,
  GamificationState,
  ErrorDialogState,
  CitationState,
  ReportDialogState,
  LoginState,
  ToastState,
  ExternalVideoState,
  RatingState,
  InfoState,
  BookclubLinksState,
  AmautasSubscriptionDialogState,
  HistoryState,
  CookiesState,
  FiltersState,
  FacetsState,
  ActiveRecordsState,
  ConfirmationDialogState,
]);
